// 机器人消息过滤工具
// 目前仅处理换行。

export const htmlFilter = {
  /**
 * 替换富文本中的\r\n为<br/>
 */
  replaceWrap(content) {
    return content.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
  },

  /**
   * 移除script
   * @param {*} content
   * @returns
   */
  removeScript(content) {
    return content.replace(/<\/?script[^>]+>/g, '');
  },

  /**
   * 过滤数字人动作标签，例：<insert-action type="动作标签英文"/>
   * @param {string} content
   * @returns
   */
  filterAISpeakerActionTag(content) {
    return content.replace(/<\/?insert-action[^>]*?>/img, '');
  },
};

export default function (cnt) {
  let content = cnt;
  content = htmlFilter.removeScript(content);
  content = htmlFilter.replaceWrap(content);
  content = htmlFilter.filterAISpeakerActionTag(content);

  return content;
};
